import { Component, input, OnDestroy, OnInit } from '@angular/core';
import { SourceEnum } from '../../../../../shared/store/typeahead/types';
import { filter, Observable } from 'rxjs';
import { InsuranceClaimStatusHistoryModel } from '../../../../../shared/store/insurance-claim/types';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GenericApiCall } from '../../../../../common/store/types';
import { SubHeaderService } from '../../../../../shared/store/subheader/subheader.service';
import { FormService } from '../../../../../shared/store/form/form.service';
import { ModalService } from '../../../../../shared/service/modal.service';
import { TimeZoneService } from '../../../../../common/time-zone/time-zone.service';
import { InsuranceClaimService } from '../../../../../shared/store/insurance-claim/insurance-claim.service';
import { untilDestroyed } from '@ngneat/until-destroy';
import { take } from 'rxjs/operators';
import { ContractStatusHistoryModel } from '../../../../../shared/store/contract/types';
import { filterTrue } from '../../../../../shared/pipe/rxjs/operators';
import {
  ModalComponent,
  ModalComponentKey,
} from 'src/app/shared/service/modal-component';

@ModalComponent(ModalComponentKey.InsuranceClaimStatusHistoryEdit)
@Component({
  selector: 'app-insurance-claim-status-history-edit-content',
  standalone: false,
  templateUrl: './insurance-claim-status-history-edit-content.component.html',
  styleUrl: './insurance-claim-status-history-edit-content.component.scss',
})
export class InsuranceClaimStatusHistoryEditContentComponent
  implements OnInit, OnDestroy
{
  readonly modalRandomIdentifier = input.required<number>();
  readonly insuranceClaimStatusHistoryId = input.required<number>();
  readonly insuranceClaimId = input.required<number>();
  readonly source = input<SourceEnum>(SourceEnum.Component);

  insuranceClaimStatusHistoryModel$: Observable<InsuranceClaimStatusHistoryModel>;

  form: FormGroup;
  apiCall: GenericApiCall<any, any>;

  fromStatus: string = '';
  toStatus: string = '';

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly insuranceClaimService: InsuranceClaimService,
    private readonly subHeaderService: SubHeaderService,
    private readonly formService: FormService,
    private readonly dynamicService: ModalService,
    private readonly timeZoneService: TimeZoneService,
  ) {
    this.insuranceClaimStatusHistoryModel$ =
      this.insuranceClaimService.getStatusHistory.value$;
  }

  ngOnInit(): void {
    this.apiCall = this.insuranceClaimService.getStatusHistory;
    this.insuranceClaimService.getStatusHistory.call({
      insuranceClaimId: this.insuranceClaimId(),
      insuranceClaimStatusHistoryId: this.insuranceClaimStatusHistoryId(),
    });

    this.form = this.formBuilder.group({
      changeDate: [undefined, Validators.required],
      fromStatus: [undefined],
      fromStatusLoc: [''],
      toStatus: [undefined, Validators.required],
      toStatusLoc: ['', Validators.required],
    });

    this.subHeaderService
      .getTriggerAction()
      .pipe(untilDestroyed(this))
      .subscribe((x) => {
        if (x == 'insuranceClaimStatusHistoryUpdate') this.onSubmit();

        this.subHeaderService.setTriggerAction('');
      });

    this.insuranceClaimStatusHistoryModel$
      .pipe(
        filter((x) => !!x),
        take(1),
      )
      .subscribe((x) => {
        this.form.patchValue({
          changeDate: this.timeZoneService.fromUtcToLocal(
            x.changeDate,
            "yyyy-MM-dd'T'HH:mm",
          ),
          fromStatus: x.fromStatus,
          fromStatusLoc: x.fromStatusLoc,
          toStatus: x.toStatus,
          toStatusLoc: x.toStatusLoc,
        });
      });
  }

  onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.formService.countErrors(this.form, true);
      return;
    }
    const changeDate = this.timeZoneService.fromLocalToUtc(
      this.form.get('changeDate')?.value,
      false,
    );

    const insuranceClaimStatusHistoryModel: InsuranceClaimStatusHistoryModel = {
      id: this.insuranceClaimStatusHistoryId(),
      insuranceClaimId: this.insuranceClaimId(),
      changeDate: changeDate!,
      fromStatus: this.form.get('fromStatus')?.value,
      toStatus: this.form.get('toStatus')?.value,

      fromStatusLoc: '',
      toStatusLoc: '',
      statusColor: '',
      userContactName: '',
      userId: undefined,
    };

    const result$ = this.insuranceClaimService.updateStatusHistory.call(
      insuranceClaimStatusHistoryModel,
    );

    result$.pipe(filterTrue(), take(1)).subscribe((result) => {
      this.formService.clear();
      switch (this.source()) {
        case SourceEnum.Component:
          // if (result.id == user.contactId) {
          //   this.userService.getCurrentUser.call();
          // }
          // this.router.navigate(['/Contacts/Contacts/Details', result.id]);
          break;
        case SourceEnum.Modal:
          this.dynamicService.outputFromDynamicComponent(
            this.modalRandomIdentifier(),
            result.id.toString(),
          );
          break;
        default:
          // this.router.navigate(['/Contacts/Contacts/Details', result.id]);
          break;
      }
    });
  }

  ngOnDestroy(): void {
    this.insuranceClaimService.updateStatusHistory.reset();
    this.insuranceClaimService.getStatusHistory.reset();
  }
}
